import { c as _c } from "react/compiler-runtime";
const MaxWidthWrapper = t0 => {
  const $ = _c(3);
  const {
    className,
    children
  } = t0;
  const t1 = `mx-auto w-full max-w-screen-xl  px-4 md:px-20 ${className}`;
  let t2;
  if ($[0] !== children || $[1] !== t1) {
    t2 = <div className={t1}>{children}</div>;
    $[0] = children;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
export default MaxWidthWrapper;